import { createThunk } from '../services/create-thunk';
import createAction from '@wix/communities-blog-client-common/dist/src/services/create-action';
import { parseAppSettings } from '../services/parse-app-settings';
import { getPostPageEnabled } from '../selectors/app-data-selectors';
import { fetchPageAppSettings } from './fetch-app-settings';

export const FETCH_POST_PAGE_SETTINGS_REQUEST = 'postPageSettings/FETCH_REQUEST';
export const FETCH_POST_PAGE_SETTINGS_SUCCESS = 'postPageSettings/FETCH_SUCCESS';
export const FETCH_POST_PAGE_SETTINGS_FAILURE = 'postPageSettings/FETCH_FAILURE';

export const fetchPostPageSettingsRequest = createAction(FETCH_POST_PAGE_SETTINGS_REQUEST);
export const fetchPostPageSettingsSuccess = createAction(FETCH_POST_PAGE_SETTINGS_SUCCESS);
export const fetchPostPageSettingsFailure = createAction(FETCH_POST_PAGE_SETTINGS_FAILURE);

export function fetchPostPageSettings() {
  return createThunk((dispatch, getState, { request }) => {
    dispatch(fetchPostPageSettingsRequest());

    const { viewMode } = parseAppSettings(undefined, getState());
    const promise = request(`/_api/settings/post-page?viewMode=${viewMode}`);
    return promise
      .then(settings => dispatch(fetchPostPageSettingsSuccess(settings)))
      .catch(() => dispatch(fetchPostPageSettingsFailure()))
      .then(() => promise);
  });
}

export const fetchAppSettingsForBusinessManager = () => (dispatch, getState) =>
  getPostPageEnabled(getState()) ? dispatch(fetchPostPageSettings()) : dispatch(fetchPageAppSettings());
